export const isMessage = (message: any): boolean => {
  if (message.type === 'message') {
    return true;
  }
  return false;
};

export const isData = (data): boolean => {
  if (data.type === 'data') {
    return true;
  }
  return false;
};
